var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: ".523%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A485E2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-27.4%",
    y: "-30%",
    width: "154.9%",
    height: "160%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    x: 52,
    y: 52,
    width: 408,
    height: 408,
    rx: 88
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "translate(81 96)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.36 42.893c-2.28 7.534 6.84-2.79 4.446-7.674s6.853 4.22 5.075 10.014c-1.777 5.795 7.18-1.669 5.73-5.841-1.448-4.169 6.85 3.508 4.47 8.379h7.527c16.504 0 51.847 6.879 69.868 50.817a15.596 15.596 0 0 0-.64 9.964l20.592 77.336c2.211 8.308 10.74 13.25 19.047 11.038l.048-.013.13-.037c5.637 18.507 5.895 35.987.166 51.18-21.062 56.053-107.22 71.511-130.377 71.93-40.393.683-113.35-25.219-130.377-71.93-5.564-15.341-5.366-32.85.286-51.434a16.108 16.108 0 0 0 1.007.304c8.204 2.184 16.622-2.608 18.962-10.728l.085-.31 20.591-77.336a15.607 15.607 0 0 0-1.127-11.039c17.996-42.512 52.34-49.592 68.923-49.74l.536-.002 5.21-.001.22-.398c3.882-7.097 4.824-12.107 2.827-15.029-3.054-4.466 9.056 3.016 6.775 10.55Zm5.842 139.044c-10.438-.058-38.46 19.189-42.696 25.752-4.871 7.548-4.871 19.785 0 27.332 1.862 2.884 12.746 3.393 19.798 11.268 10.675 11.922 19.391 30.683 22.93 29.201 3.535 1.483 12.246-17.287 22.914-29.214 7.048-7.88 17.926-8.388 19.787-11.274 4.868-7.55 4.868-19.793 0-27.344-4.237-6.57-32.308-25.811-42.733-25.721Zm67.388-60.715c-16.428 0-20.974 12.57-20.974 29.181 0 16.613 4.546 30.835 20.974 30.835s25.521-14.222 25.521-30.835c0-16.612-9.093-29.18-25.521-29.18Zm-130.467 0c-16.428 0-25.522 12.57-25.522 29.181 0 16.613 9.094 30.835 25.522 30.835 16.427 0 20.973-14.222 20.973-30.835 0-16.612-4.546-29.18-20.973-29.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.904 0c44.598 0 86.522 17.264 118.045 47.613 3.685 3.548 5.01 8.626 3.937 13.273a163.912 163.912 0 0 1 26.102 38.961c12.108 5.279 21.792 15.86 25.474 29.667 6.405 24.02-7.78 48.71-31.686 55.146-23.904 6.436-47.1-80.549-23.195-86.985a44.707 44.707 0 0 1 10.83-1.538 149.28 149.28 0 0 0-17.909-24.788 13.986 13.986 0 0 1-12.98-3.53c-26.356-25.372-61.34-39.779-98.618-39.779-37.745 0-73.126 14.774-99.559 40.694l-.798.79a13.993 13.993 0 0 1-12.76 3.785 148.934 148.934 0 0 0-16.2 22.828c3.584.064 7.216.565 10.832 1.538 23.905 6.436.71 93.421-23.195 86.985-23.905-6.436-38.091-31.126-31.686-55.146 3.682-13.807 13.365-24.387 25.474-29.666A163.845 163.845 0 0 1 51.11 63.152c-1.222-4.67.002-9.85 3.67-13.503C86.494 18.062 129.291 0 174.904 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.727 155.455a7.273 7.273 0 1 1 0 14.545 7.273 7.273 0 0 1 0-14.545Zm-9.09-5.455a3.636 3.636 0 1 1 0 7.273 3.636 3.636 0 0 1 0-7.273ZM251.727 155.455a7.273 7.273 0 1 1 0 14.545 7.273 7.273 0 0 1 0-14.545Zm-9.09-5.455a3.636 3.636 0 1 1 0 7.273 3.636 3.636 0 0 1 0-7.273Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.feccfa369e44f56cdc228926574624c7.svg";
export { ForwardRef as ReactComponent };